import { jsx } from "react/jsx-runtime";
import { Button as ButtonComp } from "@mui/material";
function Button(props) {
  const { onClick, label } = props;
  return /* @__PURE__ */ jsx(ButtonComp, { "data-testid": "TidalControlsButton", onClick, variant: "outlined", children: label });
}
export {
  Button
};
//# sourceMappingURL=Button.js.map
